import { jsx as _jsx } from "react/jsx-runtime";
import { PolygonLayer as DeckGLPolygonLayer, } from '@deck.gl/layers';
import LayerWrapper from '../layerWrapper';
function PolygonLayer(props) {
    return (_jsx(LayerWrapper, { children: _jsx(DeckGLPolygonLayer, { ...props }) }));
}
export default PolygonLayer;
